import { useState } from 'react';
import { devError } from '@/lib/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FooterNewsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleNewsletter = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error(`Newsletter signup failed: ${res.status}`);
    } catch (err) {
      devError('[Footer] Newsletter signup error:', err);
    }
    setSubmitted(true);
    setLoading(false);
  };

  return (
    <>
      <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: '#475569' }}>
        Stay Informed
      </p>
      {submitted ? (
        <p className="text-sm" style={{ color: '#38BDF8' }}>Subscribed. Thank you.</p>
      ) : (
        <form onSubmit={handleNewsletter} className="flex gap-2" aria-label="Newsletter signup">
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Work email"
            required
            aria-label="Work email for newsletter"
            className="flex-1 rounded-md px-3 py-2 text-sm text-white placeholder-slate-500 focus:outline-none focus:ring-1"
            style={{
              backgroundColor: 'rgba(255,255,255,0.07)',
              border: '1px solid rgba(255,255,255,0.15)',
            }}
            data-testid="newsletter-email"
          />
          <button
            type="submit"
            disabled={loading}
            className="px-3 py-2 rounded-md text-sm font-medium text-white transition-colors duration-200 disabled:opacity-60"
            style={{ backgroundColor: '#0EA5E9' }}
            data-testid="newsletter-submit"
          >
            &rarr;
          </button>
        </form>
      )}
    </>
  );
}
